/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { gql, useQuery } from '@apollo/client';

export const POOLED_ACCOUNT_OVERVIEW_GQL = gql`
query PooledAccountOverview {
  pooledAccountOverview {
    accounts {
      accountId
      accountList {
        type
        value
      }
      accountStatus
      pooledAccountNumber
      createdDate
      correspondenceVariant
    }
    totalAccounts
    totalActiveAccounts
    totalMatrixAccounts
    totalRequestedAccounts
  }
}
`;

export const usePooledAccountOverview = () => {
    
    const { data, loading, error } = useQuery(POOLED_ACCOUNT_OVERVIEW_GQL, {
        fetchPolicy: "network-only",
         context:{
            clientName:"/secure-storage/manage"
        }
      });
    
      return { data, loading, error };
}